import { useCallback, useEffect, useRef, useState } from "react";
import "./Todolist.scss"
import { useSelector } from "react-redux";
import newRequest from "../../utils/newRequest";
import Checkbox from '@mui/material/Checkbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { MdAdd, MdClose } from "react-icons/md";
import { showToast } from "../../toastService.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Popover,
} from "@mui/material";
import CircularButton, { CustomLoadingButton } from "../ui/CustomButton";
import { useTranslation } from "react-i18next";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { motion } from "framer-motion";
import Select from "react-select";
import moment from "moment";
import { customSelectStyles_dark, customSelectStyles_light } from "../ui/CustomSelect.jsx";

const Todolist = () => {
  const { t } = useTranslation();
  const { currentTheme } = useSelector((state) => state.theme);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");

  const [calendarDate, setCalendarDate] = useState(new Date());

  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;

  const todoTypeRef = useRef(null);
  const todoRef = useRef(null);

  const [todoTypes, setTodoTypes] = useState([]);
  const [todoDate, setTodoDate] = useState(null);
  const [todoText, setTodoText] = useState(null);
  const [todoVenue, setTodoVenue] = useState(null);
  const [todoType, setTodoType] = useState(null);
  const [todos, setTodos] = useState([]);
  const [todoDates, setTodoDates] = useState([]);


  const hasTodo = useCallback((date) => {
    return todoDates.some(
      (todoDate) =>
        todoDate.getFullYear() === date.getFullYear() &&
        todoDate.getMonth() === date.getMonth() &&
        todoDate.getDate() === date.getDate()
    );
  }, [todoDates]);


  const fetchTodos = async () => {
    try {
      const res = await newRequest.post("/todo/findGrouped", { selected_date: moment(calendarDate).format("YYYY-MM-DD") });
      // console.log(`res.data  ${JSON.stringify(res.data, null, 2)}`);
      setTodos(res.data?.todos || []);
      const dates = res.data?.dates.map(todo => {
        const parsedDate = new Date(todo.date);
        return isNaN(parsedDate.getTime()) ? null : parsedDate;
      }).filter(date => date !== null);
      setTodoDates(dates);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchActivityTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Activity Types" });
      const options = res.data.map((stage) => ({
        value: stage?.sys_code,
        label: stage?.sys_name,
      }));
      setTodoTypes(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };


  const handleCheckboxChange = async (e, id) => {
    const isChecked = e.target.checked;

    try {
      // Optional: update backend
      await newRequest.put(`/todo/upd/${id}`, {
        todo_completed: isChecked ? "Y" : "N"
      });

      // Update local state
      setTodos((prev) =>
        prev.map((todo) =>
          todo._id === id ? { ...todo, todo_completed: isChecked ? "Y" : "N" } : todo
        )
      );
    } catch (err) {
      console.error("Error updating todo:", err);
    }
  };



  const handleDeleteTask = async (taskId) => {
    try {
      //  delete task
      const res = await newRequest.delete(
        `/todo/del/${taskId}`
      );
      await fetchTodos();
    } catch (error) {
      console.error('Error updating todo:', error);
    }
  };

  const handlePopoverClick = (event) => {
    setAnchorEl(event.currentTarget);
    setTodoDate(moment(calendarDate).format("YYYY-MM-DD"));
    setTodoType({
      value: "Task",
      label: "Task",
    });
  };


  const handlePopoverEntered = () => {
    if (todoTypeRef.current) {
      todoTypeRef.current.focus();
    }
  };


  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    fetchTodos();
  }, [calendarDate]);

  useEffect(() => {
    fetchActivityTypes();
  }, []);

  return (
    <div className="todolist">
      <Calendar
        key={todoDates.map(d => d.toDateString()).join(',')}
        onChange={setCalendarDate}
        value={calendarDate}
        onActiveStartDateChange={({ activeStartDate, view }) => {
          if (view === 'month') {
            const firstDayOfMonth = new Date(
              activeStartDate.getFullYear(),
              activeStartDate.getMonth(),
              1
            );
            setCalendarDate(firstDayOfMonth);
          }
        }}
        tileContent={({ date, view }) =>
          view === 'month' && hasTodo(date) ? (
            <div className="event-indicator"></div>
          ) : null
        }
        tileClassName={({ date, view }) => {
          if (view !== 'month') return null;

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const isToday =
            date.getFullYear() === today.getFullYear() &&
            date.getMonth() === today.getMonth() &&
            date.getDate() === today.getDate();

          return isToday ? 'highlight-today' : null;
        }}
      />
      <div className="todo-navbar">
        <span className="main-title" style={{ fontSize: "16px" }}>{t('eventsAndTodo')}</span>
        <span style={{ display: "flex", alignItems: "center", gap: "3px" }}>
          <span className="todo-view-all" onClick={handlePopoverClick}>{t('add')}</span>
          {popoverOpen && <div className="backdrop" onClick={handlePopoverClose}></div>}
          <Popover
            id={id}
            open={popoverOpen}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            onEntered={handlePopoverEntered}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                color: currentTheme === "dark" ? "#fff" : "#000",
              },
            }}
          >
            <div style={{ padding: "10px" }}>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                height: "max-content",
                marginBottom: "10px"
              }}>
                <span>{t('todo').toUpperCase()}</span>
                <CircularButton currentTheme={currentTheme} onClick={handlePopoverClose} icon={<MdClose />} width={"35px"} height={"35px"} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <div className="input-item-with-label">
                  <Select
                    ref={todoTypeRef}
                    id="todoType"
                    name="todoType"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="300px"
                    value={todoType}
                    onChange={(selectedOption) => {
                      try {
                        setTodoType(selectedOption);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    options={todoTypes}
                    placeholder={t('type').toUpperCase()}
                  />
                </div>
                <div className="input-item-with-label" >
                  <textarea
                    ref={todoRef}
                    id="todo_text"
                    name="todo_text"
                    type="text"
                    placeholder="Type to do action here"
                    value={todoText}
                    row={3}
                    className="form-input-item"
                    style={{ width: "300px" }}
                    onChange={(e) => setTodoText(e.target.value)}
                  />
                </div>
                {todoType?.value !== "Task" &&
                  <div className="input-item-with-label">
                    <input
                      id="todo_venue"
                      name="todo_venue"
                      type="text"
                      placeholder={t('venue').toUpperCase()}
                      value={todoVenue}
                      className="form-input-item"
                      style={{ width: "300px" }}
                      onChange={(e) => setTodoVenue(e.target.value)}
                    />
                  </div>}
                <div className="input-item-with-label" style={{ width: "300px", display: "flex", justifyContent: "space-between" }}>
                  <input
                    id="todo_date"
                    name="todo_date"
                    type="date"
                    value={todoDate}
                    className="form-input-item"
                    style={{ width: "60%" }}
                    onChange={(e) => {
                      try {
                        const formattedDate = moment(e.target.value).format("YYYY-MM-DD");
                        setTodoDate(formattedDate);
                      } catch (error) {
                        console.log(error)
                      }
                    }}
                  />
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="right"
                    endIcon={<MdAdd />}
                    onClick={async () => {
                      try {

                        if (!todoText) {
                          setNotifyDialogTitle("Note!");
                          setNotifyDialogText(`Enter text!`);
                          setIsNotifyDialogOpen(true);
                          return;
                        }

                        if (!todoDate) {
                          setNotifyDialogTitle("Note!");
                          setNotifyDialogText(`Enter date!`);
                          setIsNotifyDialogOpen(true);
                          return;
                        }

                        if (todoType?.value !== "Task" && !todoVenue) {
                          setNotifyDialogTitle("Note!");
                          setNotifyDialogText(`Please enter venue`);
                          setIsNotifyDialogOpen(true);
                          return;
                        }
                        const res = await newRequest.post(
                          "todo/add",
                          {
                            todo_text: todoText,
                            todo_date: todoDate,
                            todo_type: todoType?.value,
                            todo_venue: todoVenue,
                            todo_completed: "N",
                          }
                        );
                        showToast("Added!", "success");
                        await fetchTodos();
                        setTodoDate(null);
                        setTodoText(null);
                        setAnchorEl(null);
                      } catch (error) {
                        console.log(error)
                      }
                    }}
                    disabled={!todoText || !todoDate}
                  >
                    {t('add')}
                  </CustomLoadingButton>
                </div>
              </div>
            </div>
          </Popover>
        </span>
      </div>
      {todos?.length === 0 &&
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "10px" }}>
          <span className="sub-title">{`No todo list found on ${moment(calendarDate).format("Do MMMM YYYY")}`}</span>
        </div>
      }
      {todos?.length > 0 &&
        <div className="todo-content">
          {todos?.map((row) => (
            <span className="todo-card" key={row._id}>
              <span className="left">{row.sr_no}.</span>
              <div className="center">
                <span className="sub-title">{row?.todo_text}</span>
                {row?.todo_venue && <span className="sub-title xrsmall soft">{`@ ${row?.todo_venue}`}</span>}
              </div>
              <div className="right">
                <Checkbox
                  checkedIcon={<CheckCircleIcon />}
                  checked={row?.todo_completed === "Y"}
                  onChange={(e) => handleCheckboxChange(e, row._id)}
                  style={{ color: '#9c27b0', margin: "0px", padding: "0px" }}
                />
                <Tooltip
                  title={`Delete ${row?.todo_text}`}
                  placement="left"
                >
                  <MdClose
                    size={20}
                    style={{
                      borderRadius: "5px",
                      padding: "3px",
                      cursor: "pointer",
                      color: "rgba(172, 33, 9 )",
                      backgroundColor: "rgba(172, 33, 9, 0.3)",
                    }}
                    onClick={() => {
                      try {
                        const action_text = `Delete ${row?.todo_text}?`;
                        handleDeleteTask(row._id);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  />
                </Tooltip>
              </div>
            </span>
          ))}
        </div>}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={handleCloseNotifyDialog}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default Todolist